import { useEffect } from "react";

import {
  Comparison,
  Footer,
  Integrations,
  Nav,
  Pricing,
  Problems,
  Reassurance,
  SceneBase,
  SceneClose,
  SceneProduct,
  WhyWhatsApp,
} from "./sections";

/** Marks the document once the visitor has scrolled past the top, so the nav
 *  can gain its edge only when there is content under it. One passive listener,
 *  written as a class on <html> rather than React state so scrolling never
 *  re-renders the page. */
function useScrolledFlag() {
  useEffect(() => {
    const root = document.documentElement;
    const on = () => root.classList.toggle("scrolled", window.scrollY > 8);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
}

/** The page is a walk through the product: the visitor scrolls from scene to
 *  scene and each one plays on its own when it arrives, the calm ones last.
 *  Brand tokens come from @fluxvia/design-tokens, imported in index.css. */
export function App() {
  useScrolledFlag();
  return (
    <div className="page">
      <Nav />
      <main>
        <SceneProduct />
        <SceneBase />
        <WhyWhatsApp />
        <Comparison />
        <Problems />
        <Integrations />
        <Reassurance />
        <Pricing />
        <SceneClose />
      </main>
      <Footer />
    </div>
  );
}
